import { useState } from "react"
import { useFormContext, useWatch } from "react-hook-form"
import BetterDocIcon from "@/assets/images/icons/BetterDoc-logo.svg"
import { Button } from "@/components/ui/button"
import { BetterDocMissingFieldDialog } from "@/modules/patients/detail/better-doc/components/better-doc-missing-field-dialog"
import { BetterDocSearchDialog } from "@/modules/patients/detail/better-doc/components/better-doc-search-dialog"
import { useBetterDocAvailability } from "@/modules/patients/detail/better-doc/hooks/useBetterDocAvailability"
import { canRequestBetterDocRecommendation } from "@/modules/patients/detail/better-doc/lib/point-of-care-better-doc-rules"
import { PointOfCareFormType } from "@/modules/patients/detail/progress-note/point-of-care/schema"

export const BetterDocButton = () => {
  const [openBetterDoctorSearchDialog, setOpenBetterDoctorSearchDialog] = useState(false)
  const [openMissingFieldDialog, setOpenMissingFieldDialog] = useState(false)

  const { hasBetterDocFeature, missingBetterDocFields } = useBetterDocAvailability()

  const { control } = useFormContext<PointOfCareFormType>()

  const betterDocSuggestionStatus = useWatch({ control, name: "betterDocSuggestionStatus" })
  const careProviderId = useWatch({ control, name: "careProviderId" })

  const isDisabled = !canRequestBetterDocRecommendation({ careProviderId, betterDocSuggestionStatus })

  const handleCloseDialog = () => {
    setOpenBetterDoctorSearchDialog(false)
  }

  const openDialog = () => {
    setOpenBetterDoctorSearchDialog(true)
  }

  const handleCloseMissingFieldDialog = () => {
    setOpenMissingFieldDialog(false)
  }

  const openMissingFieldDialogHandler = () => {
    setOpenMissingFieldDialog(true)
  }

  const handleBetterDoc = () => {
    if (hasBetterDocFeature) {
      openDialog()
    } else {
      openMissingFieldDialogHandler()
    }
  }

  return (
    <>
      <Button
        id="better-doc-button"
        variant="primary"
        data-testid="better-doc-button"
        onClick={handleBetterDoc}
        disabled={isDisabled}
        className="bg-success hover:bg-success-hovered focus:bg-success-pressed active:bg-success-pressed shrink-0 pr-4 pl-2 whitespace-nowrap">
        <img src={BetterDocIcon} alt="better-doc-icon" />
        BetterDoc
      </Button>

      {openBetterDoctorSearchDialog && <BetterDocSearchDialog onClose={handleCloseDialog} />}

      <BetterDocMissingFieldDialog
        open={openMissingFieldDialog}
        onClose={handleCloseMissingFieldDialog}
        missingFields={missingBetterDocFields}
      />
    </>
  )
}
